import { Suspense, lazy } from "react";
import type { RouteObject } from "react-router";

import type { DashboardRunsDetailsQuery } from "@app_schema";

import type { Breadcrumb } from "@application/types/breadcrumb";

import { DASHBOARD_RUNS_DETAILS_LOADER } from "@application/loaders/dashboard_runs_details_loader";
import { DASHBOARD_RUNS_LIST_LOADER } from "@application/loaders/dashboard_runs_list_loader";

import { DASHBOARD_RUNS_LINK } from "@application/navigation/dashboard_runs_link";

import { Loader } from "@styled/loader";

const DashboardRunsDetails = lazy(() =>
  import("./run_details").then((m) => ({ default: m.DashboardRunsDetails })),
);
const DashboardRunsList = lazy(() =>
  import("./runs_list").then((m) => ({ default: m.DashboardRunsList })),
);

export const DASHBOARD_RUNS_ROUTE = {
  path: "runs",
  handle: DASHBOARD_RUNS_LINK,
  children: [
    {
      index: true,
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardRunsList />
        </Suspense>
      ),
      loader: DASHBOARD_RUNS_LIST_LOADER,
    },
    {
      path: ":id",
      element: (
        <Suspense fallback={<Loader />}>
          <DashboardRunsDetails />
        </Suspense>
      ),
      loader: DASHBOARD_RUNS_DETAILS_LOADER,
      handle: (data: DashboardRunsDetailsQuery): Breadcrumb => ({
        name: `#${data.run.id} - ${data.run.workflow.name}`,
        to: `/dashboard/runs/${data.run.id}`,
      }),
    },
  ],
} satisfies RouteObject;
